import { observer } from 'mobx-react';
import { useEffect, useMemo } from 'react';
import GroupStore from '../../../GroupStore';
import GroupReactions from '../../../GroupStore/Reactions';
import GroupsStore from '../../../GroupsStore';
import GroupsOptionsReactions from '../../../GroupsStore/Options/Reactions';
import GroupsReactions from '../../../GroupsStore/Reactions';
import { GroupResource } from '../../../GroupsStore/Types';
import { MulticheckStore } from '../../../Multicheck/Store';
import ModalStore from '../../Modal/Store';
import GroupsState from '../../People/Groups/GroupsState';

/**
 * The current Groups list, without its own heading and Add Group button:
 * the title row's segmented control and CTA replace them. Rebuilt in Phase 2.
 */
function Groups() {
  const groupsStore = useMemo(() => new GroupsStore(), []);
  const groupStore = useMemo(() => new GroupStore(groupsStore), [groupsStore]);
  const modalStore = useMemo(() => new ModalStore(), []);
  const multicheckStore = useMemo(() => new MulticheckStore<GroupResource>(), []);

  useEffect(() => groupsStore.loading(1), [groupsStore]);

  return (
    <div className="mx-auto max-w-clientPortalMaxWidth">
      <GroupsState
        store={groupsStore}
        modalStore={modalStore}
        groupStore={groupStore}
        multicheckStore={multicheckStore}
      />
      <GroupsReactions store={groupsStore} fireImmediately />
      <GroupsOptionsReactions store={groupsStore.optionsStore} fireImmediately />
      <GroupReactions store={groupStore} fireImmediately />
    </div>
  );
}

export default observer(Groups);
